import React from 'react';
import './PageNotFound.scss';
import { useHistory } from 'react-router';

export const PageNotFound = () => {
    const { goBack } = useHistory();

    return (
        <div className="content-area-inner page-not-found">
            <h2>Page not found.</h2>
            <br />
            Return to the <a onClick={goBack}>previous page</a>, go to the <a href="/">homepage</a> or contact our{' '}
            <a href="mailto:borrowbox@bolinda.com">support team</a>.
        </div>
    );
};
